/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Store } from '../../models/store';

export interface StoresStoreIdGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function storesStoreIdGet(http: HttpClient, rootUrl: string, params: StoresStoreIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Store>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Store>;
    })
  );
}

storesStoreIdGet.PATH = '/stores/{storeId}';
